import React from 'react';

const CementaryIcon = (props) => {
  return (
    <img
      alt="Jaskinia"
      src="/static/images/icons/tourist_attractions/cementary.svg"
      {...props}
    />
  );
};

export default CementaryIcon;
